// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zNqT","input":"styles_input__3ookY"};